export default __webpack_public_path__ + "static/media/55.522f9655.jpg";